import * as Axios from 'axios';
import BaseService from '../common/BaseService';
import store from '@/store';
import { IMarketProduct } from '@/domain/bankwatch';

export default class MarketProductsService extends BaseService {
  /**
   * Get all market products
   */
  public async getAllMarketProducts(): Promise<IMarketProduct[]> {
    const apiConfig: Axios.AxiosRequestConfig = {
      method: 'get',
      url: `${store.state.apiBase}/bankwatch/market-products/`,
      headers: {
        Authorization: `Bearer ${store.state.$auth.token}`
      }
    };

    const res: Axios.AxiosResponse = await this.makeAxiosCall(apiConfig);
    return res.data as IMarketProduct[];
  }

  /**
   * Get market product by organization ID
   */
  public async getMarketProductByOrgId(orgId: string): Promise<IMarketProduct> {
    const apiConfig: Axios.AxiosRequestConfig = {
      method: 'get',
      url: `${store.state.apiBase}/bankwatch/market-products/${orgId}`,
      headers: {
        Authorization: `Bearer ${store.state.$auth.token}`
      }
    };

    const res: Axios.AxiosResponse = await this.makeAxiosCall(apiConfig);
    return res.data as IMarketProduct;
  }
}
